/* eslint @typescript-eslint/naming-convention: 0 */
import type { ExperienceSortType } from '@/wabunka-src/common/features/Experience/utils/experienceListSort';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface ViewExperienceListParams {
  sort_type: ExperienceSortType;
  result_count: number;
}

/**
 * 発火タイミング：一覧の描画が確定した際（1表示につき1回）。絞り込み・ページ送り・ソート切替の
 * 再取得ごとに送り直す。
 * ※ select_experience_in_list と対で、ソート別の一覧→詳細遷移率の分母に使う。
 */
export const sendGAWabunkaViewExperienceListEvent = (sortType: ExperienceSortType, resultCount: number) => {
  sendWabunkaGAEvent('view_experience_list', { sort_type: sortType, result_count: resultCount });
};
